import React from 'react';
import PropTypes from 'prop-types';

import './typeahead.scss';

const Itens = (props) => {
    let { item, isMouse } = props;
    let nameClass = item.active ? "autocomplete-active" : ""

    return (
        <div className={`autocomplete-items ${nameClass}`}
            onClick={(event) => {
                props.onClick(event, item);
            }}
            onMouseOver={(event) => {
                item.active = true;
                isMouse= true;
                props.onMouseOver(event, item, isMouse);
            }}
            onMouseOut={(event) => {
                item.active = false;
                isMouse= false;
                props.onMouseOut(event, item, isMouse);
            }}>

            <strong>{item.letter}</strong>
            {item.letters}
        </div>
    )
}

Itens.defaultProps = {
    item: {}
}

Itens.propTypes = {
    item: PropTypes.shape({
        letter: PropTypes.string.isRequired,
        letters: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        active: PropTypes.bool
    })
}

export default Itens;